module.exports = __webpack_public_path__ + "static/media/tax-img.aa670a50.jpg";